<template>
	<div>
		<div class="section-gap primary pb-5">
			<v-container grid-list-xl pt-1>
				<v-layout
					row
					wrap
					align-center
					text-center
					text-sm-center
					text-xl-left
					text-lg-left
				>
					<v-flex xs12 sm12 md6 lg6 xl6>
						<div class="subscribe-content">
							<h1 class="translate-right white--text">
								¡Solicita una demo y conoce nuestro sistema!
							</h1>
							<p class="translate-left white--text">
								Nada mejor que ver con tus propios ojos
							</p>
							<v-btn
								color="success"
								rounded
								href="https://wa.me/51958805900"
								target="_new"
							>
								<v-icon dark left>mdi-whatsapp</v-icon> Escribir al WhatsApp</v-btn
							>
						</div>
					</v-flex>
					<v-flex xs12 sm12 md6 lg6 xl6>
						<div class="subscribe-content">
							<div class="emb-aside-banner-v1 text-right">
								<img
									class="emb-card"
									alt="aside-banner"
									src="/static/images/functionalities.jpg"
									width="547"
									height="315"
								/>
							</div>
						</div>
					</v-flex>
				</v-layout>
			</v-container>
		</div>
		<v-container grid-list-xl pt-10 mb-6>
			<v-layout row wrap align-center justify-center>
				<v-flex xs12 sm12 md12 lg8 xl8>
					<div class="subscribe-content">
						<v-card class="pa-4">
							<v-form v-model="valid">
								<v-row>
									<v-col cols="12" md="12">
										<v-text-field
											v-model="form.number"
											:rules="rucRules"
											:counter="11"
											label="RUC"
											required
											outlined
											dense
											append-icon="mdi-magnify"
											@click:append="getData"
										></v-text-field>
									</v-col>

									<v-col cols="12" md="12">
										<v-text-field
											v-model="form.name"
											label="Razón social"
											outlined
											dense
											readonly
										></v-text-field>
									</v-col>

									<v-col cols="12" md="12">
										<v-text-field
											v-model="form.email"
											:rules="emailRules"
											label="Correo electrónico"
											outlined
											dense
											required
										></v-text-field>
									</v-col>
									<v-col cols="12" md="12">
										<v-text-field
											v-model="form.phone"
											:rules="phoneRules"
											label="Teléfono"
											:counter="9"
											outlined
											dense
											required
										></v-text-field>
									</v-col>
									<v-col cols="12" md="12">
										<v-select
											:items="items"
											label="Rubro de tu negocio"
											outlined
											dense
										></v-select>
									</v-col>
									<v-col cols="12" lg="6">
										<v-date-picker
											v-model="date"
											:min="date"
											width="300"
											locale="es"
										></v-date-picker>
									</v-col>
									<v-col cols="12" lg="6" class="text-right">
										<v-time-picker
											min="08:00"
											max="20:00"
											v-model="picker"
										></v-time-picker>
									</v-col>
								</v-row>
							</v-form>
							<v-btn color="accent" rounded>
								Solicitar demo
							</v-btn>
						</v-card>
					</div>
				</v-flex>
			</v-layout>
		</v-container>
		<v-snackbar v-model="snackbar" color="success" top right>
			¡Exito, su RUC es válido!

			<!-- <template v-slot:action="{ attrs }">
                <v-btn color="error" text v-bind="attrs" @click="snackbar = false">
                    Close
                </v-btn>
            </template> -->
		</v-snackbar>
	</div>
</template>

<script>
export default {
	data() {
		return {
			e1: 1,
			valid: false,
			form: {
				number: '',
				name: '',
				email: '',
				phone: '',
				business_turn: '',
			},
			rucRules: [
				(v) => !!v || 'Requerido',
				(v) => v.length == 11 || 'El RUC debe tener de 11 caracteres',
			],
			phoneRules: [
				(v) => !!v || 'Requerido',
				(v) => v.length == 11 || 'El teléfono debe tener de 9 caracteres',
			],
			emailRules: [
				(v) => !!v || 'Requerido',
				(v) => /.+@.+/.test(v) || 'El correo electrónico debe ser válido',
			],
			items: [
				{ value: 1, text: 'Distribuidora' },
				{ value: 2, text: 'Restaurante' },
				{ value: 3, text: 'Pastelería' },
				{ value: 4, text: 'Café' },
				{ value: 5, text: 'Retail' },
				{ value: 6, text: 'Zapatería' },
				{ value: 7, text: 'Botica' },
				{ value: 8, text: 'Farmacia' },
				{ value: 9, text: 'Centro educativo' },
				{ value: 10, text: 'Otro' },
			],
			picker: null,
			date: new Date().toISOString().substr(0, 10),
			dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
			snackbar: false,
		};
	},
	computed: {
		computedDateFormatted() {
			return this.formatDate(this.date);
		},
	},
	beforeCreate() {
		document.title = "Solicitar demostración | Sislii";
	},
	methods: {
		getData() {
			this.snackbar = true;
		},
		formatDate(date) {
			if (!date) return null;

			const [year, month, day] = date.split('-');
			return `${month}/${day}/${year}`;
		},
	},
};
</script>
